<template lang="pug">
  .back-cursor.mb-2(@click="back")
    span
      BIconChevronLeft
    span {{BackVal}}
</template>


<script>
 import { BIconChevronLeft } from 'bootstrap-vue';

 export default {
   props: {
     BackVal: {
       type: String,
       default: 'Back',
     },
   },
   components : {
     BIconChevronLeft
   },
   methods: {
     back() {
       this.$emit('back');
     }
   }
 };
</script>
<style lagn="scss" scoped>
 .back-cursor {
	 cursor: pointer;
	 font-family: $font-sans-serif;
	 font-weight: bold;
	 font-size: 3vmin;
	 margin-top:0;
	 padding-top:0;
 }
 @media (max-width: 768px) {
   .back-cursor {
     font-size: 1.2rem; /* or 1.2rem, or 4vw for slight scaling */
   }
 }

</style>
